import { useContext, useEffect } from 'react';

import { findAndMatchRoute } from '@confluence/route-manager/entry-points/RouteManager.ts';
import {
	BASE,
	WIKI,
	HOME,
	ALL_UPDATES,
	DASHBOARD_ACTION_LEGACY,
} from '@confluence/named-routes/entry-points/routes.ts';
import { namedRoutes } from '@confluence/named-routes/entry-points/named-routes.ts';
import { ExperienceTrackerContext } from '@confluence/experience-tracker/entry-points/component.ts';
import { startExperienceForRoute } from '@confluence/experience-tracker/entry-points/startExperienceForRoute.ts';

const routeNamesThatRedirectToHome = [
	BASE.name,
	WIKI.name,
	ALL_UPDATES.name,
	DASHBOARD_ACTION_LEGACY.name,
];

export const useExperienceFailureForRoute = (url: string, entryPoint?: string): void => {
	const experienceTracker = useContext(ExperienceTrackerContext);

	useEffect(() => {
		let routeMatch = findAndMatchRoute(namedRoutes, url);

		// If the route redirects to /home, convert the URL to a HOME URL
		if (!!routeMatch?.name && routeNamesThatRedirectToHome.includes(routeMatch?.name)) {
			const routeQuery = routeMatch?.query;
			const routeHash = routeMatch?.hash;
			const homeUrl = HOME.toUrl(undefined, { query: routeQuery, hash: routeHash });
			routeMatch = findAndMatchRoute(namedRoutes, homeUrl);
		}

		if (routeMatch) {
			// The monolith reuses its trace ID as the CSP nonce; SSR exposes its trace separately.
			// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
			const traceId =
				document.head.querySelector<HTMLScriptElement>('script[nonce]')?.nonce ||
				window.__SSR_TRACE_ID__;

			startExperienceForRoute(routeMatch, 0);
			experienceTracker.fail({
				error: new Error('FATAL ERROR: Error SPA rendered'),
				attributes: {
					entryPoint: entryPoint ?? 'unknown',
					...(traceId && { traceId }),
				},
			});
		}
	}, [experienceTracker, url, entryPoint]);
};
